export function CoachOptions({ options, pickedKey, onPick }) {
  if (!options?.length) return null;
  const hasPick = pickedKey != null;
  return (
    <div className="coach-options">
      {options.map((opt) => {
        const isSelected = opt.k === pickedKey;
        return (
          <button
            key={opt.k}
            type="button"
            onClick={() => !hasPick && onPick?.(opt)}
            disabled={hasPick && !isSelected}
            className={[
              'coach-option',
              isSelected ? 'is-selected' : hasPick ? 'is-dimmed' : '',
            ].filter(Boolean).join(' ')}
          >
            <span className="coach-option-key">{opt.k}</span>
            <span>{opt.t}</span>
          </button>
        );
      })}
    </div>
  );
}

export default CoachOptions;
